import { ButtonBase } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

interface IChipRootProps {
  active?: boolean;
  gold?: boolean;
  toolbar?: boolean;
}

export const ChipRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) =>
    prop !== "active" && prop !== "gold" && prop !== "toolbar",
})<IChipRootProps>(({ theme, active, gold, toolbar }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    gap: theme.spacing(0.75),
    height: 36,
    padding: theme.spacing(0, 1.75),
    borderRadius: 999,
    border: "1px solid transparent",
    backgroundColor: isDark ? theme.palette.grey[900] : theme.palette.grey[100],
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    transition: theme.transitions.create(
      ["background-color", "border-color", "color"],
      { duration: 150 }
    ),

    "& svg": {
      fontSize: 16,
    },

    "& .FilterChip-clearIcon": {
      boxSizing: "content-box",
      fontSize: 14,
      padding: "11px 14px 11px 6px",
      margin: "-11px -14px -11px auto",
      opacity: 0.7,

      "&:hover": {
        opacity: 1,
      },
    },

    "&:hover": {
      backgroundColor: isDark
        ? theme.palette.grey[800]
        : theme.palette.grey[200],
    },

    "&.Mui-disabled": {
      opacity: 0.5,
    },

    ...(active && {
      backgroundColor: theme.palette.text.primary,
      color: theme.palette.background.paper,

      "&:hover": {
        backgroundColor: alpha(theme.palette.text.primary, 0.85),
      },
    }),

    ...(gold && {
      borderColor: theme.palette.gold.dark,
      backgroundColor: alpha(theme.palette.gold.main, 0.16),
      color: theme.palette.gold.dark,

      "&:hover": {
        backgroundColor: alpha(theme.palette.gold.main, 0.32),
      },

      "& .FilterChip-lockIcon": {
        fontSize: 13,
      },
    }),

    ...(toolbar && {
      height: 32,
      padding: theme.spacing(0, 1.625),

      "& svg": {
        fontSize: 18,
      },

      "& .FilterChip-chevron": {
        fontSize: 16,
        color: theme.palette.text.secondary,
      },

      "& .FilterChip-lockIcon": {
        fontSize: 14,
      },

      ...(gold &&
        !isDark && {
          borderColor: alpha(theme.palette.gold.dark, 0.45),
          backgroundColor: alpha(theme.palette.gold.main, 0.1),

          "&:hover": {
            backgroundColor: alpha(theme.palette.gold.main, 0.22),
          },
        }),
    }),
  };
});

export const Label = styled("span")({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
});

export const Value = styled(Label)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
